import ProjectsService from "@/services/server/ProjectsService.js";
import ProjectsFirebaseService from "@/services/firebase/Projects/ProjectService.js";
import Utils from '@/scripts/Utils';
import store from '@/store/index'
import NotificationsService from "../../../services/server/NotificationsService";
import { getProjectNotifyConfig } from "@/services/firebase/ProjectsNotifyConfig/ProjectsNotifyConfigService";
import { TRANSLATE_STATUS_TO_MESSAGE } from "@/pages/Projects/Utils/StatusConstants.js";
import UsersService from "../../../services/firebase/Users/UsersService";

const STEPS = {
    PROSPECTING: "prospecting",
    DIAGNOSTIC: "diagnostic",
    APPROVAL: "approval",
    CLOSING: "closing",
    CONTRACTS: "contracts",
    MATERIALS: "materials",
    INSTALLATION: "installation",
    FINISH: "finish",
    NOTIFICATIONS: "notifications",
    OUT: 'out',
}

const TranslateSteps = {
    prospecting: "Prospecção",
    diagnostic: "Waterscan",
    approval: "Aprovação",
    closing: "Fechamento",
    contracts: "Contratos",
    materials: "Entrega",
    installation: "Waterfix",
    finish: "Finalizado",
    notifications: "Notificação",
    out: 'out'
}

async function updateProjectSteps(idProject, currentStep, enable = true, isRollback = false, messageList = []) {
    try {
        const [statusProject, project_data] = await ProjectsService.getProjectById(idProject);

        let currentIndex = project_data.steps.findIndex(s => s.name === currentStep);
        if (currentIndex < 0) {
            console.log("project_data.steps", project_data.steps)
            if(currentStep === STEPS.FINISH){
                project_data.steps.push({
                    name: 'finish',
                    isCurrentStep: false,
                    completed: false
                })
                currentIndex = project_data.steps.findIndex(s => s.name === currentStep);
            }else throw new Error(`Passo atual ${currentStep} não encontrado.`);
        }
        console.log("project_data.steps", project_data.steps)

        const currentActiveIndex = project_data.steps.findIndex(s => s.isCurrentStep);

        const updatedSteps = project_data.steps.map(step => ({ ...step }));
        console.log("updatedSteps", updatedSteps)

        if (!isRollback) {
            console.log("updatedSteps[currentIndex]", updatedSteps[currentIndex])
            console.log("currentIndex", currentIndex)
            if (updatedSteps[currentIndex].completed) {
                console.log(`Passo ${currentStep} já está completo. Nenhuma alteração necessária.`);
                return project_data.steps;
            }

            if (currentIndex > 0) {
                updatedSteps[currentIndex - 1].completed = true;
                updatedSteps[currentIndex - 1].isCurrentStep = false;
            }

            updatedSteps[currentIndex].isCurrentStep = true;
            updatedSteps[currentIndex].completed = false;
        } else {
            rollbackSteps(updatedSteps, currentIndex);
        }

        if (currentIndex !== currentActiveIndex) {
            if (project_data.configs?.wpp_notification ?? true) {
                await sendChangeStepNotification(project_data, currentStep, isRollback, messageList);
            }
            await ProjectsService.updateProject(idProject, { steps: updatedSteps });
        }

        return updatedSteps;

    } catch (e) {
        await this.createWarningLog(idProject, STEPS.DIAGNOSTIC, `Notificação não enviada`, 'Notificações');
        console.error(e);
    }
}
function rollbackSteps(steps, currentIndex) {
    steps.forEach((step, index) => {
        if (index > currentIndex) {
            step.isCurrentStep = false;
            step.completed = false;
        }
    });

    steps[currentIndex].isCurrentStep = true;
    steps[currentIndex].completed = false;
}

function buildFranchiseeNotificationData(project_data, messageBody) {
    return {
        template: 'HXe070cf89b75fc8bcd0715b3ff95ead57',
        id_user: project_data.id_franchisee,
        variables: {
            '1': Utils.formatDateDayJs(new Date(), "DD/MM/YYYY [às] HH:mm").toString(),
            '2': project_data.project_name.toString(),
            '4': new Date().getFullYear().toString(),
            '3': messageBody,
        }
    };
}

async function getGlobalReceptorsForStatuses(id_franchisee, statusCodes){
    const projectNotifyConfig = await getProjectNotifyConfig(id_franchisee);
    const receptorsMap = projectNotifyConfig?.notification_receptors || {};
    const codes = Array.isArray(statusCodes) ? statusCodes : [statusCodes];

    return Object.entries(receptorsMap)
        .filter(([receptorId, statuses]) =>
            receptorId &&
            Array.isArray(statuses) &&
            statuses.some(status => codes.includes(status))
        )
        .map(([receptorId]) => receptorId);
}

async function sendNotification(project_data, statusCodes, message, id_franchisee = null){
    let globalReceptors = []
    if(id_franchisee !== null && id_franchisee !== undefined){
        globalReceptors = await getGlobalReceptorsForStatuses(id_franchisee, statusCodes);
    }
    const receptors = getReceptorsForStatuses(project_data, statusCodes);

    const allReceptors = [...globalReceptors, ...receptors];
    if (allReceptors.length === 0) {
        //console.log(`Nenhum receptor configurado para o(s) statuses ${statusCodes}`);
        return;
    }
    
    await sendRequestToNotifyReceptors(
        project_data, 
        allReceptors,
        message
    );
}

function getReceptorsForStatuses(project_data, statusCodes) {
    const allReceptors = project_data.configs?.notification_receptors || [];
    return allReceptors
        .filter(receptor => 
            receptor.statuses && 
            receptor.statuses.some(status => 
                statusCodes.includes(status)
            )
        )
        .map(receptor => receptor.id)
        .filter(id => id && id !== undefined && id !== null && id !== '');
}

async function buildADMNotificationData(project_data, messageBody, userId){
    let franchiseeName = "";
    try {
        const user = await UsersService.getUsersById(project_data.id_franchisee);
        if (user && Array.isArray(user)) {
            franchiseeName = user[0]?.name || "";
        } else if (user && typeof user === "object") {
            franchiseeName = user.name || "";
        }
    } catch (e) {
        console.error("Erro ao buscar nome do franqueado:", e);
    }
    
    const names = `${project_data.project_name} - ${franchiseeName}`;
    return {
        template: 'HXe070cf89b75fc8bcd0715b3ff95ead57',
        id_user: userId,
        variables: {
            '1': Utils.formatDateDayJs(new Date(), "DD/MM/YYYY [às] HH:mm").toString(),
            '2': names,
            '4': new Date().getFullYear().toString(),
            '3': messageBody,
        }
    }
}
// Função para validar telefone
function hasValidPhone(user) {
    return (
        user &&
        user.metadata &&
        typeof user.metadata.phone === 'string' &&
        user.metadata.phone.trim() !== '' &&
        user.metadata.phone !== null &&
        user.metadata.phone !== undefined
    );
}
async function sendRequestToNotifyReceptors(project_data, messageList, messageBody = "" ) {
    
    if (project_data.configs?.wpp_notification ?? true) {
        if (!messageList || messageList.length === 0 || messageList.length > 10 ) {
            return;
        }
        
        const message = messageBody !== "" 
            ? messageBody 
            : `Ocorreu um error na geração da mensagem`;
        
        try {
            // Filter only valid IDS
            const validUserIds = messageList.filter(id => id && id !== undefined && id !== null && id !== '');
            const users = await UsersService.getUsersByIdList(validUserIds);            

            // Filter users with valid phone
            const usersWithPhone = users.filter(hasValidPhone);
            const userIdsWithPhone = usersWithPhone.map(u => u.id);

            // Build the notification list only for users with valid phone
            const data = await Promise.all(
                userIdsWithPhone.map(async userId => {
                    const notification = await buildADMNotificationData(project_data, message, userId);
                    if (notification && notification.id_user) return notification;
                    else return null;
                })
            );
            const filteredData = data.filter(item => item && item.id_user);
            if (filteredData.length > 0) {
                await NotificationsService.bootProjectNotification(filteredData);
            } 
        } catch (error) {
            console.error("Error ao enviar notificação para colaborador:", error);
        }
    } 
}

async function sendChangeStepNotification(project_data, currentStep, isRollback, messageList) {
    const messageBody = isRollback
        ? `Lamentamos informar que seu passo foi revertido para *${TranslateSteps[currentStep]}* devido a uma nova análise.`
        : `Gostaríamos de informar que o(a) *${TranslateSteps[currentStep]}* está habilitado no seu projeto!`;

    try {
        const data = buildFranchiseeNotificationData(project_data, messageBody);
        messageList.push(data);
        await NotificationsService.bootProjectNotification(messageList);
    } catch (e) {
        console.error("Erro ao enviar notificação:", e);
    }
}

const createLog = async (projectId, stepName, status) => {
    const createdAt = new Date()
    await ProjectsFirebaseService.createProjectLog(projectId, {
        stepName,
        status,
        createdAt
    });
};
const addStatusProject = async (projectId, stepName, status, currentStep, franchisee = true) => {
    try {
        const createdAt = new Date();

        if (currentStep === stepName) {
            if (franchisee) {
                await ProjectsService.updateProject(projectId, {
                    currentStatusFranchisee: status,
                    currentHourStatusFranchisee: createdAt
                });
            } else { 
                await ProjectsService.updateProject(projectId, {
                    currentStatusADM: status,
                    currentHourStatusADM: createdAt
                });
            }
        }
        /*
            this conditional is to avoid send multiples notification for the ADMINS
            if it is necessary to make it so that franchisees can also receive internal notifications, 
            the logic will need to be improved 
        */
        if(!franchisee) {
            const [any, project_data] = await ProjectsService.getProjectById(projectId);
            if (project_data) {
                await sendNotification(project_data, [status], `${TRANSLATE_STATUS_TO_MESSAGE[status]}`, project_data.id_franchisee);
            }
        }     
    } catch (error) {
        console.error("Error em addStatusProject: ", error)
    }
};
const createBaseLog = async (projectId, stepName, status, type, currentStep, franchisee = true) => {
    const { id, name } = store.state.currentUser.currentUser
    const createdAt = new Date();

    await ProjectsFirebaseService.createProjectLog(projectId, {
        userName: name,
        userId: id,
        stepName,
        type,
        status,
        createdAt,
    });
    if (currentStep === stepName) {
        if (franchisee) {
            await ProjectsService.updateProject(projectId, {
                lastLogMessageFranchisee: `${status} - ${Utils.formatDate(createdAt, '<dd>/<MM>/<YYYY> as <HH>:<mm>')}`
            });
        } else {
            await ProjectsService.updateProject(projectId, {
                lastLogMessageADM: `${status} - ${Utils.formatDate(createdAt, '<dd>/<MM>/<YYYY> as <HH>:<mm>')}`
            });
        }
    }
};
const createErrorLog = async (projectId, stepName, status, currentStep) => {
    createBaseLog(projectId, stepName, status, "error", currentStep)
};
const createInfoLog = async (projectId, stepName, status, currentStep) => {
    createBaseLog(projectId, stepName, status, "info", currentStep)
};
const createWarningLog = async (projectId, stepName, status, currentStep) => {
    createBaseLog(projectId, stepName, status, "warning", currentStep)
};
const createSuccessLog = async (projectId, stepName, status, currentStep) => {
    createBaseLog(projectId, stepName, status, "success", currentStep)
};


export default {
    STEPS,
    TranslateSteps,
    createLog,
    createInfoLog,
    createErrorLog,
    addStatusProject,
    createSuccessLog,
    createWarningLog,
    updateProjectSteps,
    buildFranchiseeNotificationData,
    sendNotification,
    getReceptorsForStatuses,
    sendRequestToNotifyReceptors
};

